import React, {useEffect, useRef, useState} from "react";
import DataTable from 'react-data-table-component'
import {Link} from "react-router-dom";
import axios from "axios";
import {Button, Col, Dropdown, Form, Modal, Row, Spinner, Table} from "react-bootstrap";
import {Trash, Edit, Eye, Tool, Layers} from 'react-feather';
import {Lang, websetting} from "../../../helpers/websetting";
import Moment from "moment";
import {SystemSetting} from "../../../constants/system";
import {useTranslation} from "react-i18next";

function Bills(){
    const t = useTranslation()
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([]);
    const [Organization, setOrganization] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(SystemSetting.rowInPage);

    const [show, setShow] = useState(false);
    const [info, setInfo] = useState(true);
    const [infoData, setInfoData] = useState({});

    const handleClose = () => {
        setShow(false);
        setValidated(false);
        setInfo(true);
        setLoadingModal(false)
        setInfoData({})
    }

    const handleShow = () => {
        setShow(true);
    }

    const getOrg = () => {
        axios.get(websetting.apiUrl + 'auth/api/v1/organizations/',
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setOrganization(response.data.data);
            setLoading(false);
        }).catch(function (error) {

        });
    }

    const columns = [
        {
            name: t.t("iot.global.status"),
            selector: (row : any) => row.statusDesc,
        },{
            name: t.t("iot.global.organization"),
            selector: (row : any) => row.organizationName,
        },{
            name: t.t("iot.global.createdDate"),
            selector: (row : any) => Moment(row.createDate).format(websetting.dateFormat),
        },{
            name: t.t("iot.global.actions"),
            cell : (row : any) => <div><Button variant={"outline-danger"} onClick={()=>del(row.billIdPk)} className={"rounded-circle"}><Trash size={15} /></Button> <Button onClick={()=>edit(row.billIdPk)}  variant={"outline-info"} className={"rounded-circle"}><Edit size={15} /></Button> <Button  variant={"dark"}  onClick={()=>showInfo(row.billIdPk)} className={"rounded-circle "}><Eye  size={15} /></Button> <Link to={"../BillDevice/"+row.billIdPk}    className={"btn btn-sm btn-rounded rounded-circle btn-success   "}><Layers size={15} className={"mt-1"} /></Link></div>,
        }
    ];

    const fetchDta = async (page:any) => {
        setLoading(true);
        const p = page - 1
        axios.get(websetting.apiUrl + 'inventory-service/api/v1/Bom/?pageNO='+p+'&pageSize='+SystemSetting.rowInPage,
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setData(response.data.data);
            setLoading(false);
            getOrg()
        }).catch(function (error) {

        });
    };
    const handlePageChange = (page :any) => {
        fetchDta(page);
    };
    const handlePerRowsChange = async (newPerPage:any, page:any) => {
        fetchDta(page)
    };
    useEffect(() => {
        fetchDta(1); // fetch page 1 of users
    }, []);

    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        if (form.checkValidity() === true) {
            event.preventDefault();
            setLoadingModal(true)
            const PKid = event.target.Id.value;
            if(event.target.Id.value > 0){
                axios.put(websetting.apiUrl + 'inventory-service/api/v1/Bom/'+event.target.Id.value,
                    {
                        "createDate": "2022-02-04T07:50:25.258Z",
                        "createdBy": "",
                        "organizationDTO": {
                            "createDate": "",
                            "createdBy": "",
                            "description": "",
                            "name": "",
                            /*organizationIdPk : event.target.Org.value,*/
                            "updateDate": "2022-02-04T07:50:25.258Z",
                            "updatedBy": ""
                        },
                        /*"organizationIdFk": event.target.Org.value,*/
                        "status": event.target.Status.value,
                        "statusDesc": "",
                        "updateDate": "2022-02-04T07:50:25.258Z",
                        "updatedBy": ""
                    },
                    {
                        method: "put",
                        headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    const index = data.findIndex( (array) => {
                        return parseInt(array["billIdPk"]) === parseInt(PKid)
                    });

                    let prevState = JSON.parse(JSON.stringify(data));
                    prevState[index].statusDesc = response.data.statusDesc
                    prevState[index].organizationName = response.data.organizationName
                    prevState[index].createdBy = response.data.createdBy

                    setData(prevState)
                    setShow(false)
                    setLoadingModal(true)
                }).catch(function (error) {
                    setLoadingModal(true)
                });
            }else {
                axios.post(websetting.apiUrl + 'inventory-service/api/v1/Bom/',
                    {
                        "createDate": "2022-02-04T07:50:25.258Z",
                        "createdBy": "",
                        "organizationDTO": {
                            "createDate": "",
                            "createdBy": "",
                            "description": "",
                            "name": "",
                            organizationIdPk : event.target.Org.value,
                            "updateDate": "2022-02-04T07:50:25.258Z",
                            "updatedBy": ""
                        },
                        "organizationIdFk": event.target.Org.value,
                        "status": "",
                        "statusDesc": "",
                        "updateDate": "2022-02-04T07:50:25.258Z",
                        "updatedBy": ""
                    },
                    {
                        method: "post",
                        headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    setData(data.concat(response.data))
                    setShow(false)
                    setLoadingModal(true)
                }).catch(function (error) {
                    setLoadingModal(true)
                });

            }
        }
    };

    const del = (id:any) => {
        if(window.confirm('Are you sure you wish to delete this item?')) {
            axios.delete(websetting.apiUrl + 'inventory-service/api/v1/Bom/' + id,
                {
                    method: "delete",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                const newData = data.filter((array) => {
                    return array["billIdPk"] !== id
                });
                setData(newData)
            }).catch(function (error) {
            });
        }
    }

    const edit = (id:any) => {
        setShow(true);
        if(id > 0){
            setLoadingModal(true)

            axios.get(websetting.apiUrl + 'inventory-service/api/v1/Bom/'+id,
                {
                    method: "get",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
            }).catch(function (error) {
            });
        }
    }

    const showInfo = (id:any) => {
        setShow(true);
        setInfo(false);
        if(id > 0){
            setLoadingModal(true)
            axios.get(websetting.apiUrl + 'inventory-service/api/v1/Bom/'+id,
                {
                    method: "get",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
            }).catch(function (error) {
            });
        }
    }





    const infos =  JSON.parse(JSON.stringify(infoData))

    return(
        <div className={""}>
            <div className="lightbox">
                <div className={""}>
                    <div className="pagetitle text-uppercase">
                        <div className={"d-flex justify-content-between"}>
                            <div className={"d-inline-flex"}>
                                <Tool className={"feather"} size={21} />
                                {t.t("iot.global.billsTitle")}
                            </div>
                            <div className={"d-inline-flex align-content-end"}>
                                <Button   variant={"warning"}  onClick={()=>edit(0)}>+ {t.t("iot.global.newBill")}</Button>

                            </div>
                        </div>

                    </div>
                    <DataTable progressPending={loading}
                               pagination
                               paginationServer
                               paginationTotalRows={totalRows}
                               progressComponent ={<Spinner className={"my-5"} animation={"border"} variant={"warning"} title={"Please Wait"} />}
                               onChangeRowsPerPage={handlePerRowsChange}
                               onChangePage={handlePageChange} columns={columns} data={data} />

                </div>
            </div>

            <Modal size={"lg"} centered={true}
                   show={show}
                   onExited={handleClose}
                   onHide={handleClose}
                   backdrop="static">
                <Modal.Header >
                    <Modal.Title><Tool className={"feather"} /> {t.t("iot.global.billsTitle")}</Modal.Title>
                </Modal.Header>
                <Form noValidate validated={validated}  onSubmit={handleSubmit}>
                    <Modal.Body>
                        {info ?
                            <div>{
                                loadingModal ? <div className={"text-center my-3"}><Spinner animation={"border"} variant={"danger"} /></div> :

                                    <Row>
                                        <Form.Group hidden controlId="Id" >
                                            <Form.Control type={"hidden"}   value={infos.billIdPk}  />
                                        </Form.Group>
                                        {!infos.billIdPk &&
                                        <Col md={12}>
                                            <Form.Group className="my-2" controlId="Org">
                                                <Form.Label>{t.t("iot.global.organizationName")}:</Form.Label>
                                                <Form.Select required aria-label={t.t("iot.global.organizationName")}
                                                             aria-describedby="msgInput1">
                                                    {Object.keys(Organization).map((titles, i) => {
                                                        return (
                                                            <option
                                                                selected={infos.organizationIdFk == JSON.parse(JSON.stringify(Organization[i])).organizationIdPk ? true : false}
                                                                value={JSON.parse(JSON.stringify(Organization[i])).organizationIdPk}>{JSON.parse(JSON.stringify(Organization[i])).name}</option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid" id="msgInput1">
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        }
                                        {infos.billIdPk &&
                                        <Col md={12}>
                                            <Form.Group className="my-2" controlId="Status">
                                                <Form.Label>{t.t("iot.global.status")}:</Form.Label>
                                                <Form.Select   defaultValue={infos.status} required aria-label={t.t("iot.global.status")}
                                                             aria-describedby="msgInput4">
                                                    <option value="2">Attached to Customer</option>
                                                    <option value="1">Shipped</option>
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid" id="msgInput4">
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        }


                                    </Row>
                            }
                            </div>
                            :
                            <div>
                                {
                                    loadingModal ? <div className={"text-center my-5"}><Spinner animation={"border"} variant={"danger"} /></div> :
                                        <div>
                                            <Table     hover>
                                                <tbody>
                                                <tr><td>ID</td><td>{infos.billIdPk}</td></tr>
                                                <tr><td>{t.t("iot.global.status")}</td><td>{infos.statusDesc}</td></tr>
                                                <tr><td>{t.t("iot.global.createdBy")}</td><td>{infos.createdBy}</td></tr>
                                                <tr><td>{t.t("iot.global.createdDate")}</td><td>{infos.createDate}</td></tr>
                                                <tr><td>{t.t("iot.global.updatedBy")}</td><td>{infos.updatedBy}</td></tr>
                                                <tr><td>{t.t("iot.global.updatedDate")}</td><td>{infos.updateDate}</td></tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                }
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-dark" onClick={handleClose}>{t.t("iot.global.close")}</Button>
                        {info &&  <Button type={"submit"}  variant="warning">{t.t("iot.global.save")}</Button>}

                    </Modal.Footer>
                </Form>
            </Modal>

        </div>
    )
}
export default Bills;